module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weui-wepay-flow",
    class: {
      'weui-wepay-flow_vertical': _vm.orientation ===
        'vertical'
    }
  }, [_c('div', {
    staticClass: "weui-wepay-flow__bd"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8cf1fd6e"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/flow/flow.vue
// module id = 724
// module chunks = 0